function ResourceLinksEnumMethods(Enumeration, locationLinkBuilderServant, ResourceLinks, ngTypeUtility) {
  return Enumeration.useDefinitionAsEnum({
    URL: {
      buildDisplay: function buildDisplay(value) {
        var urlPrefixExpression = new RegExp('://');
        var urlContainsPrefix = urlPrefixExpression.exec(value.value);
        var appendedUrl;

        if (_.isNull(urlContainsPrefix)) {
          appendedUrl = 'http://' + value.value;
        } else {
          appendedUrl = value.value;
          //regex has the starting index stored, but we add 3 since the expression is 3 characters long
          value.value = value.value.slice(urlContainsPrefix.index + 3, value.value.length);
        }

        return {
          link: appendedUrl,
          mixPanelActionTypeValue: 'Visited Website',
          icon: 'network',
          ariaLabel: 'website',
          desktopActionable: true,
          description: value
        };
      }
    },
    PHONE: {
      buildDisplay: function buildDisplay(value) {
        let formattedPhoneNumber = value.value;
        if (ngTypeUtility.phoneNumber.isValidPhoneNumber(formattedPhoneNumber)) {
          formattedPhoneNumber = ngTypeUtility.phoneNumber.getDisplayNumber(formattedPhoneNumber);
        }
        return {
          link: 'tel://' + formattedPhoneNumber,
          mixPanelActionTypeValue: 'Called Phone',
          icon: 'telephone',
          ariaLabel: 'phone',
          desktopActionable: false,
          description: value
        };
      }
    },
    EMAIL: {
      buildDisplay: function buildDisplay(value) {
        return {
          link: 'mailto:' + value.value,
          mixPanelActionTypeValue: 'Emailed',
          icon: 'envelope',
          ariaLabel: 'email',
          desktopActionable: true,
          description: value,
          type: ResourceLinks.EMAIL
        };
      }
    },
    TIME: {
      buildDisplay: function buildDisplay(value) {
        return {
          link: undefined,
          mixPanelActionTypeValue: undefined,
          icon: 'clock',
          ariaLabel: 'time',
          desktopActionable: false,
          description: value
        };
      }
    },
    LOCATION: {
      buildDisplay: function buildDisplay(value) {
        return {
          link: locationLinkBuilderServant.createLocationLink(value),
          mixPanelActionTypeValue: undefined,
          icon: 'map_marker',
          ariaLabel: 'map',
          desktopActionable: true,
          description: value
        };
      }
    },
    GENERIC: {
      buildDisplay: function buildDisplay(value) {
        return {
          link: undefined,
          mixPanelActionTypeValue: undefined,
          icon: 'info_circle',
          ariaLabel: 'info',
          desktopActionable: false,
          description: value
        };
      }
    }
  });
}

angular
  .module('capability-ng-resources')
  .constant(
    'ResourceLinks',
    Enumeration('ResourceLinks', {
      // eslint-disable-line new-cap

      URL: 'Web',
      TIME: 'Hours',
      EMAIL: 'Email',
      PHONE: 'Phone',
      GENERIC: 'Generic',
      LOCATION: 'Location'
    })
  )
  .factory('ResourceLinksEnum', ResourceLinksEnumMethods);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/types/resource_link_enum.es.js